import { getApp } from 'firebase/app';
import { getFunctions, httpsCallable } from 'firebase/functions';

// ✅ Define the callable ONCE, at module level to avoid TDZ issues
const app = getApp();
const functions = getFunctions(app, 'us-central1'); // must match your deployed region
const callStartGameLaunch = httpsCallable(functions, 'startGameLaunch');

export async function startGameLaunchCallable({ gameId, dryRun = false }) {
  if (!gameId) throw new Error('Missing gameId');
  console.log('🧭 using httpsCallable for startGameLaunch', { gameId, dryRun });

  try {
    const res = await callStartGameLaunch({ gameId: String(gameId), dryRun });
    console.log('✅ startGameLaunch result:', res?.data);
    return res?.data ?? null;
  } catch (err) {
    console.error('❌ startGameLaunch failed:', err);
    throw err;
  }
}
